import React, { useState } from "react";

import { Grid } from "@mui/material";

import { QuickAccessMenu } from "components/admin/QuickAccessMenu";
import { useUserContext } from "contexts/UserContext";
import { Header } from "components/libComponents/Header";
import { SideMenu } from "components/libComponents/SideMenu";

export const FrameWrapper = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const { hasProsumer } = useUserContext();

  const handleMenuToggle = () => setIsMenuOpen((prevState) => !prevState);
  const handleClosing = () => setIsMenuOpen(false);

  return (
    <>
      <SideMenu
        open={isMenuOpen}
        onClose={handleClosing}
        isProsumer={hasProsumer}
      />
      <Header onDrawerToggle={handleMenuToggle} />
      <Grid container component="main" sx={{ flex: 1, gridArea: "main" }}>
        {children}
      </Grid>
      <QuickAccessMenu />
    </>
  );
};
